import React, { useMemo } from 'react';
import { openCustomModal } from '../../../actions/modal';
import ButtonScogoOrange from '../../../common/Buttons/ButtonScogoOrange';
import { paymnetVia } from '../../Payments/PaymentController';
import { canViewBudgetTicket, canViewCustomerBillingTicket, canViewIncentiveTicket, eligibleToAddAdditionalAmount, getTicketOwner, MilestoneSubStatus, MilestoneType, TicketAgentRole } from '../TicketController';
import { PriceWithLabel } from '../TicketTableComponent';
import { ScogoID, validateNumberValue } from '../../../utils/common';
import PaymentsDetails from '../../Payments/Modals/PaymentsDetails';
import { ticket as ticketPath } from '../../../router/roleWisePageRoute';
import IconToolTip from '../../../common/IconToolTip';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { convertIntoRupee } from '../../../utils/utils';
import { useSelector } from 'react-redux';
import { BillingStatus, getTicketBillingStatus } from '../../CustomerBilling/CustomerBillingController';

const textLabelClass = 'text-font11 text-scogogray';
const textValueClass = 'text-font12 text-black';


export const getPartnerBasePayment = ({ partner_base_payment, additional_expenses, additional_amount_paid, psp_id, psp_base_payment, loggedUserPaymentRatio, ticketSpPaymentRatio = 1, loggedUserId, acceptedSpId, signOffAccept, ticket_owned_by, assignToScogo } = {}) => {
    let basePayment = validateNumberValue(partner_base_payment) * ticketSpPaymentRatio;

    if (signOffAccept === 1) {
        basePayment = validateNumberValue(partner_base_payment);
    } else if (loggedUserId === acceptedSpId) {
        basePayment = validateNumberValue(partner_base_payment) * loggedUserPaymentRatio;
    }
    let payment = basePayment + validateNumberValue(additional_expenses) + validateNumberValue(additional_amount_paid);
    const ticketOwner = getTicketOwner({ ticket_owned_by, assign_to_scogo: assignToScogo });
    if (ticketOwner === 'Scogo' && validateNumberValue(psp_id) === 0 && validateNumberValue(psp_base_payment) && parseFloat(psp_base_payment) > 0) {
        payment += psp_base_payment
    }
    return payment;
}

export const Price = ({ ticket }) => {
    const newLoggedUserData = useSelector(state => state.auth.newLoggedUserData);
    const isSameOrgTicket = newLoggedUserData.orgMemberships.find(({ id }) => id === ticket.helpdesk_id);
    const showAddNewPriceButton = isSameOrgTicket && eligibleToAddAdditionalAmount(ticket.milestones, ticket.status, newLoggedUserData.org.type, newLoggedUserData.org.id);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const openVendorpaymentDetail = () => {
        let heading = 'Payments';
        let modalComponent = <PaymentsDetails ticket={ticket} ticketId={ticket?.id} />;
        let modalWidth = '85rem',
            modalHeight = 'auto';
        dispatch(openCustomModal({ modalComponent, heading, modalWidth, modalHeight }));
    }


    const payment = useMemo(() => {
        const isScogoMember = newLoggedUserData.orgMemberships.find(({ id }) => id === ScogoID);
        const findPsp = ticket?.agents?.find((agent) => agent.role === TicketAgentRole.PSP);
        const findCluster = ticket?.agents?.find((agent) => agent.role === TicketAgentRole.CLUSTER);
        const findWarehouse = ticket?.agents?.find((agent) => agent.role === TicketAgentRole.WAREHOUSE_OWNER);

        const isLoginUserIsSP = newLoggedUserData.user.roles.find((elem) => elem.label === 'SP');

        let incentive = 0;
        let partner = 0;
        let customer = 0;

        if (isScogoMember) {
            customer += convertIntoRupee(ticket.customer_cost);

            if (ticket.milestones?.length > 0) {
                ticket.milestones.forEach(({ payments, id, type, milestone_status }) => {
                    if (!payments) return;
                    if (milestone_status === MilestoneSubStatus.HARD_CLOSED) return;

                    const mileStoneSp = ticket?.agents?.find((ag) => ag.role === TicketAgentRole.SP && id === ag.milestone_id);

                    if (isLoginUserIsSP && mileStoneSp) {
                        const isAccepted = mileStoneSp.agent.id === newLoggedUserData.user.id;
                        if (isAccepted) {
                            partner += convertIntoRupee(payments.SP_SERVICE);

                            // if (!findPsp && payments?.PSP_INCENTIVE > 0 && type !== MilestoneType.RMA) {
                            //     partner += convertIntoRupee(payments.PSP_INCENTIVE);
                            // };

                            if (mileStoneSp && !isNaN(mileStoneSp.ticket_payment_ratio)) {
                                partner = partner * mileStoneSp.ticket_payment_ratio;
                            };
                        };
                    } else {
                        if (payments?.SP_SERVICE > 0) {
                            partner += convertIntoRupee(payments.SP_SERVICE);
                        }

                        // if (!findPsp && payments?.PSP_INCENTIVE > 0 && type !== MilestoneType.RMA) {
                        // partner += convertIntoRupee(payments.PSP_INCENTIVE);
                        // };

                        if (!findPsp && payments?.PSP_INCENTIVE > 0 && type === MilestoneType.RMA) {
                            incentive += convertIntoRupee(payments.PSP_INCENTIVE);
                        };

                        if (mileStoneSp && !isNaN(mileStoneSp.ticket_payment_ratio)) {
                            partner = partner * mileStoneSp.ticket_payment_ratio;
                        };
                    };

                    if (findPsp && payments?.PSP_INCENTIVE > 0) {
                        incentive += convertIntoRupee(payments.PSP_INCENTIVE);
                    };

                    if (findCluster && payments?.CLUSTER_INCENTIVE > 0) {
                        incentive += convertIntoRupee(payments.CLUSTER_INCENTIVE);
                    };

                    if (findWarehouse && payments?.WAREHOUSE_OWNER_INCENTIVE > 0) {
                        incentive += convertIntoRupee(payments.WAREHOUSE_OWNER_INCENTIVE);
                    }
                })
            }

        };

        if (!isScogoMember && ticket.helpdesk_id === ScogoID && ticket.org_id === newLoggedUserData.org.id) {
            const isAllMilestonerIsHardClosed = ticket.milestones.every((elem) => elem.milestone_status === MilestoneSubStatus.HARD_CLOSED)
            if (!isAllMilestonerIsHardClosed) {
                customer += convertIntoRupee(ticket.customer_cost);
            }
        }


        if (Array.isArray(ticket.milestone_wise_additional_approved_amount)) {
            ticket.milestone_wise_additional_approved_amount.forEach((additonal_amount) => {

                if (isLoginUserIsSP) {
                    const isAccepted = ticket?.agents?.find((ag) => ag.role === TicketAgentRole.SP && additonal_amount.milestone_id === ag.milestone_id && ag.agent.id === newLoggedUserData.user.id);
                    if (isAccepted) {
                        partner += convertIntoRupee(additonal_amount.vendor);
                    }
                } else {
                    partner += convertIntoRupee(additonal_amount.vendor);
                }
                incentive += convertIntoRupee(additonal_amount.incentive);
                customer += (convertIntoRupee(additonal_amount.customer) * -1);
            })
        }

        const formattedValue = (value) => Number.isInteger(value) || value === parseFloat(value.toFixed(2))
            ? value
            : value.toFixed(2);

        return { partner: formattedValue(partner), incentive: formattedValue(incentive), customer: formattedValue(customer) };
    }, [newLoggedUserData.orgMemberships, ticket.milestones, ticket?.agents, ticket.milestone_wise_additional_approved_amount, ticket.customer_cost, newLoggedUserData.user.id, newLoggedUserData.user.roles, ticket.helpdesk_id, ticket.org_id, newLoggedUserData.org.id]);


    const showVendorPrice = useMemo(() => {
        const memberships = newLoggedUserData.orgMemberships;
        const membershipIds = new Set(memberships.map(({ id }) => id));
        return membershipIds.has(ticket.helpdesk_id);
    }, [newLoggedUserData.orgMemberships, ticket.helpdesk_id]);

    const showIncentive = useMemo(() => {
        const memberships = newLoggedUserData.orgMemberships;
        const membershipIds = new Set(memberships.map(({ id }) => id));
        return canViewIncentiveTicket(ticket) && membershipIds.has(ticket.helpdesk_id) && membershipIds.has(ScogoID);
    }, [ticket, newLoggedUserData.orgMemberships]);

    const showCustomerBilling = useMemo(() => {
        const memberships = newLoggedUserData.orgMemberships;
        const membershipIds = new Set(memberships.map(({ id }) => id));
        if (ticket.org_id === newLoggedUserData.org.id && ticket.helpdesk_id === ScogoID && canViewCustomerBillingTicket(ticket)) return true;
        return canViewCustomerBillingTicket(ticket) && membershipIds.has(ScogoID);
    }, [ticket, newLoggedUserData.orgMemberships, newLoggedUserData.org.id]);

    const getFinancialStateStyle = (state) => {
        const financialStates = {
            'GOOD': { label: 'Within Budget', className: 'bg-green-100 text-green-700' },
            'OVER_BUDGET': { label: 'Over Budget', className: 'bg-yellow-100 text-yellow-700' },
            'LOSS': { label: 'Loss', className: 'bg-red-100 text-red-700' }
        };
        return financialStates[state] || { label: state, className: 'bg-blue-50', labelClass: 'text-blue-600' };
    };

    return (
        <div className='pl-2'>
            {canViewBudgetTicket(ticket) ? (
                <div className={`${getFinancialStateStyle(ticket.financial_state).className} flex items-center gap-2 px-2 py-1 rounded-md max-w-max`} >
                    <span className='text-font10 font-medium'>Budget</span>
                    <span className=' flex items-center'>
                        <span className='text-font12'>₹ {convertIntoRupee(ticket.metadata.per_ticket_budget_in_paisa)}</span>
                    </span>
                </div>
            ) : null}

            {showCustomerBilling ? (
                <PriceWithLabel onClick={() => { }} valueClass={`${textValueClass} whitespace-nowrap`} labelClass={`${textLabelClass} whitespace-nowrap`} label={'Billing'} value={payment.customer} className='flex gap-2 cursor-pointer' renderLabel={<RenderApprovalRecievedLabel ticket={ticket} />
                } />
            ) : null}


            {showVendorPrice ? <PriceWithLabel onClick={openVendorpaymentDetail} valueClass={`${textValueClass} hover:text-scogoorange`} labelClass={`${textLabelClass} hover:text-scogoorange`} label={'Vendor'} value={payment.partner} className='flex gap-2 cursor-pointer' renderLabel={!showCustomerBilling && newLoggedUserData.org.id === ScogoID ? <RenderApprovalRecievedLabel ticket={ticket} /> : undefined} /> : <></>}

            {showIncentive ? <PriceWithLabel valueClass={textValueClass} labelClass={textLabelClass} label={'Incentives'} value={payment.incentive} className='flex gap-2 break-words' /> : null}

            {showAddNewPriceButton && (
                <ButtonScogoOrange buttonClass='text-font10' textOrComponent={'Add New'} onClick={() => openTicketPaymentModal(ticket, { navigate, dispatch })} />
            )}

            {/* {showCustomerPaidToScogo && ticket.customer_paid_to_scogo > 0 && <PriceWithLabel valueClass={textValueClass} labelClass={textLabelClass} label={'Vendor'} value={ticket.customer_paid_to_scogo} className='flex gap-2 break-words' />} */}
        </div>
    );
};

export const openTicketPaymentModal = (ticket, { heading = 'Payments', navigate, dispatch }) => {
    const showAdditionalAmountApprove = ticket?.ticket_basic_payment_status?.payment_via === paymnetVia.throughWallet && ticket.request_additional_amount > 0;
    const showApproveSignOff = true
    let path = `${ticketPath.path}/${ticket.id}/edit-payout?source=ticket`
    if (showAdditionalAmountApprove) path = `${path}&showAdditionalAmountApprove=true`
    if (showApproveSignOff) path = `${path}&showApproveSignOff=true`
    if (heading) path = `${path}&heading=${heading}`
    navigate(path)
};


const RenderApprovalRecievedLabel = ({ ticket }) => {
    let content = '';
    let titleText = '';
    let bgcolor = '';

    const status = getTicketBillingStatus(ticket);
    if (status === BillingStatus.INVOICED) return <span className='bg-scogobgsky text-white ml-2 rounded-md text-font09 px-3 whitespace-nowrap'>Invoiced</span>;

    if (status === BillingStatus.SUBMITTED) {
        content = 'CBS';
        titleText = 'Customer Billing Submitted';
        bgcolor = 'bg-purple-600';
    } else if (status === BillingStatus.REJECTED) {
        content = 'CDR';
        titleText = 'Customer Billing Rejected';
        bgcolor = 'bg-red-600';
    } else if (status === BillingStatus.RECEIVED) {
        content = 'CBR';
        titleText = 'Customer Billing Received';
        bgcolor = 'bg-scogogoing';
    } else {
        content = 'CBP';
        titleText = status === BillingStatus.REVOKED ? 'Customer Billing Revoked' : 'Customer Billing Approval Pending';
        bgcolor = 'bg-scogoorange';
    }

    return <IconToolTip title={titleText}><span className={`${bgcolor} text-white ml-2 rounded-md text-font09 px-3 whitespace-nowrap`}>{content}</span></IconToolTip>
}
